import { type Directive, nextTick, watch } from "vue"
import { useUserStoreHook } from "@/store/modules/user"

/** 角色指令 */
export const role: Directive = {
  mounted(el, binding) {
    const userStore = useUserStoreHook()
    const comment = document.createComment(" v-role 占位符 ")
    let hasRole = false

    const updateVisibility = async () => {
      const { value } = binding
      if (value && Array.isArray(value) && value.length > 0) {
        const roles = userStore.roles
        hasRole = roles.some((role) => value.includes(role))
        await nextTick()
        if (!hasRole && el.parentNode) {
          el.parentNode.replaceChild(comment, el)
        } else if (hasRole && comment.parentNode) {
          comment.parentNode.replaceChild(el, comment)
        }
      } else {
        throw new Error(`需要角色！例如 v-role="['admin','editor']"`)
      }
    }

    // 初始检查
    updateVisibility()

    // 监听角色变化
    const stopWatch = watch(() => userStore.roles, updateVisibility, { deep: true })

    // 存储清理函数
    el._roleDirectiveCleanup = () => {
      stopWatch()
      if (!hasRole && comment.parentNode) {
        comment.parentNode.replaceChild(el, comment)
      }
    }
  },
  unmounted(el) {
    // 清理 watch 和恢复原始元素
    if (el._roleDirectiveCleanup) {
      el._roleDirectiveCleanup()
    }
  },
}
